"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var ga_sidecar_1 = require("@engine/ga-sidecar");
var settings_sidecar_1 = require("@engine/settings-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var uiFps_sidecar_1 = require("@ui/uiFps-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageBackground_sidecar_1 = require("@voyage/background/voyageBackground-sidecar");
var diveTileData_sidecar_1 = require("@voyage/dive/tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("@voyage/dive/tilemap/diveTilemap-sidecar");
var voyageCarryableData_sidecar_1 = require("@voyage/entities/voyageCarryableData-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var diveKeyboard_sidecar_1 = require("@voyage/input/diveKeyboard-sidecar");
var voyageMissionData_sidecar_1 = require("@voyage/missions/voyageMissionData-sidecar");
var voyageMessages_sidecar_1 = require("@voyage/multi/voyageMessages-sidecar");
var voyageParticlesData_sidecar_1 = require("@voyage/particles/voyageParticlesData-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
var voyageStarmaps_sidecar_1 = require("@voyage/starmap/voyageStarmaps-sidecar");
var voyageSystemsData_sidecar_1 = require("@voyage/systems/voyageSystemsData-sidecar");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveParticlesData_sidecar_1 = require("@dive/effects/diveParticlesData-sidecar");
var diveObjectsData_sidecar_1 = require("@dive/entities/diveObjectsData-sidecar");
var rogueGlyphs_sidecar_1 = require("@dive/fonts/rogueGlyphs-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var diveCrew_enemy_data_sidecar_1 = require("@voyage/crew/diveCrew_enemy_data-sidecar");
var diveCrew_hero_data_sidecar_1 = require("@voyage/crew/diveCrew_hero_data-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageTileData_sidecar_1 = require("@voyage/tilemap/voyageTileData-sidecar");
var voyageUiBuyStuff_data_sidecar_1 = require("@voyage/ui/voyageUiBuyStuff_data-sidecar");
var voyageUiNav_data_sidecar_1 = require("@voyage/ui/voyageUiNav_data-sidecar");
function create() {
    ga_sidecar_1.ga.init('voyage');
    perf2_sidecar_1.perf2.setEnabled(diveDebug_sidecar_1.diveDebug.debug_perf2Enabled);
    spritesUtil_sidecar_1.spritesUtil.setDefaultScale(2);
    settings_sidecar_1.settings.create('voyage:settings', 1);
    voyageTestParams_sidecar_1.voyageTestParams.loadTestMode();
    voyageUiNav_data_sidecar_1.voyageUiNav_data.registerAll();
    voyageParticlesData_sidecar_1.voyageParticlesData.registerAll();
    voyageTileData_sidecar_1.voyageTileData.registerAll();
    voyageCarryableData_sidecar_1.voyageCarryableData.registerAll();
    voyageSystemsData_sidecar_1.voyageSystemsData.registerAll();
    voyageUiBuyStuff_data_sidecar_1.voyageUiBuyStuff_data.registerAll();
    voyageMissionData_sidecar_1.voyageMissionData.registerAll();
    voyageMessages_sidecar_1.voyageMessages.registerAll();
    diveParticlesData_sidecar_1.diveParticlesData.registerAll();
    diveCrew_hero_data_sidecar_1.diveCrew_hero_data.registerAll();
    diveCrew_enemy_data_sidecar_1.diveCrew_enemy_data.registerAll();
    diveObjectsData_sidecar_1.diveObjectsData.registerAll();
    diveTileData_sidecar_1.diveTileData.registerAll();
    var soundsJson = common_sidecar_1.common.getPhaserScene().cache.json.get('audioSprite2');
    voyageSounds_sidecar_1.voyageSounds.load(soundsJson, '/assets/music');
    // crokinoleSounds.load(soundsJson, '/assets/music')
    voyageLayers_sidecar_1.voyageLayers.create();
    rogueGlyphs_sidecar_1.rogueGlyphs.setDefaultLayer(voyageLayers_sidecar_1.voyageLayers.getLayers().ui1);
    // buttons2.setDefaultFrames(buttons2.defaultFramesBasic)
    // buttons2.setDefaultFont(echoFonts.getData().font6)
    uiFps_sidecar_1.uiFps.create(voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    uiFps_sidecar_1.uiFps.setOpen(true);
    clickEater_sidecar_1.clickEater.create();
    diveKeyboard_sidecar_1.diveKeyboard.create();
    // voyageTilemap.create()
    voyageStarmaps_sidecar_1.voyageStarmaps.setVisible(false);
    voyageStarmaps_sidecar_1.voyageStarmaps.create();
    voyageBackground_sidecar_1.voyageBackground.create();
    //chessWebsockets.create()
    // New dive stuff
    diveTilemap_sidecar_1.diveTilemap.create();
    voyageWebsockets_sidecar_1.voyageWebsockets.create();
    voyageGameManager_sidecar_1.voyageGameManager.goLoading();
    // Test bodies
    // let b = voyageBodies.create()
    // voyageBodies.moveToXY(b, 100, 100)
    // testing
    // voyageUiNav.setOpen(true)
}
exports.create = create;
